import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";

export function CancellationPendingNotice() {
  const { t } = useTranslation("app");
  return (
    <div
      role="status"
      className="flex items-start gap-3 rounded-medium border border-warning-200 bg-warning-50 px-4 py-3 text-warning-800"
    >
      <AlertTriangle aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0" />
      <div className="space-y-0.5">
        <p className="text-sm font-semibold">
          {t("orders.cancellationPendingTitle")}
        </p>
        <p className="text-tiny">{t("orders.cancellationPendingBody")}</p>
      </div>
    </div>
  );
}
